export default "__VITE_ASSET__45SaUwAQ__"